import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsParitysubstrateComponent } from './simple-icons-paritysubstrate.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsParitysubstrateComponent ],
    exports:      [ SimpleIconsParitysubstrateComponent ],
    bootstrap:    []
})
export class SimpleIconsParitysubstrateModule {}
